import { orderReturnedValidate } from '../../application/dtos/order_returned_validate'

export class OrderReturnedEntity {
    constructor({id, unique_order_number, shipment_number, order_returned, details}){
        this.id = id,
        this.unique_order_number = unique_order_number,
        this.shipment_number = shipment_number,
        this.order_returned = order_returned
        this.details = details
    }

    isValid() {
        return orderReturnedValidate(this);
    }
}